<section *ngIf="!hideHeader" id="home365_general_modal_container" class="flex home365-padding padding-medium position-relative"
         [ngClass]="headerClasses">
  <div class="flex-1">
    <h2 [ngClass]="{'minimize-title': data.minimizeTitle}">{{modalTitle}}</h2>
    <h4 *ngIf="modalSubTitle">{{modalSubTitle}}</h4>
  </div>
  <mat-icon id="close_icon" class="material-icons pointer position-absolut" *ngIf="canClose" (click)="close()">close</mat-icon>
</section>
<ng-container *ngIf="showComponent else btnTemplate">
  <ng-container [cdkPortalOutlet]="componentPortal"></ng-container>
</ng-container>
<section id="home365_popup_overlay" class="home365-padding flex column center" *ngIf="executing">
  <ng-container *ngIf="!actionCompleted else massage">
    <lib-home365-loader size="m"></lib-home365-loader>
  </ng-container>
</section>

<ng-template #massage>
  <i class="material-icons">{{actionData.successes ? 'check' : 'clear'}}</i>
  <h4>{{actionData.massage}}</h4>
</ng-template>
<ng-template #btnTemplate>
  <section *ngIf="data.buttons" class="home365-padding flex center home365-popup-buttons">
    <button class="home365-button" *ngFor="let btn of data.buttons; let i = index" [class]="btn.classes" (click)="buttonClicked(btn)">{{btn.text}}</button>
  </section>
</ng-template>
<div id="triangle" #triangle></div>
